$R.addLang('fr', {
    'size': 'Taille',
    'remove-size':  'Supprimer taille de police'
});